import { useParams, useNavigate } from "react-router-dom";
import {
  ArrowLeftIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import { useGetTopic } from "../../../../api/queries";
import Spinner from "../../../../componentLibrary/Spinner";
import { SectionHeader } from "../../../../componentLibrary/SectionPanel";
import CheckinDefinitionList from "./components/CheckinDefinitionList";

export default function CheckinDefinitionsPage() {
  const { topicId } = useParams<{ topicId: string }>();
  const navigate = useNavigate();

  const { data: topic, isLoading } = useGetTopic(topicId);

  const topicTitle = topic?.title ?? "Topic";

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner className="w-8" />
      </div>
    );
  }

  return (
    <div className="pt-4">
      <div className="mb-4">
        <button
          type="button"
          onClick={() => navigate(`/admin/toolboxes/${topicId}`)}
          className="flex items-center gap-1.5 text-sm text-electrum-300 hover:text-electrum transition-colors mb-4 w-fit"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          Back to Toolbox Manager
        </button>

        <div className="flex items-center gap-3">
          {topic?.icon && (
            <img
              src={topic.icon.src}
              alt={topic.icon.alt || topicTitle}
              className="w-8 h-8 object-contain shrink-0"
            />
          )}
          <h1 className="text-2xl font-bold text-gray-800">
            {topicTitle} Check-In Definitions
          </h1>
        </div>
        <p className="text-sm text-gray-500 mt-1 ml-11">
          Manage check-in definition versions for this topic. Only one version
          can be active at a time.
        </p>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white p-5">
        <SectionHeader
          icon={
            <ClipboardDocumentListIcon className="w-5 h-5 text-electrum-300 shrink-0" />
          }
          title="Check-In Definitions"
          action="+ New version"
          actionTo={`/admin/toolboxes/${topicId}/checkin-definitions/new`}
        />
        {topicId ? (
          <CheckinDefinitionList topicId={topicId} topicTitle={topicTitle} />
        ) : (
          <p className="text-sm text-gray-400">No topic selected.</p>
        )}
      </div>
    </div>
  );
}
